import Icon from 'vue-awesome/components/Icon'

Icon.register({
  trending_down_rounded: {
    paths: [
      {
        d: 'M16.85 17.15l1.44-1.44-4.88-4.88-3.29 3.29a.996.996 0 01-1.41 0l-6-6.01A.996.996 0 114.12 6.7L9.41 12l3.29-3.29a.996.996 0 011.41 0l5.59 5.58 1.44-1.44a.5.5 0 01.85.35v4.29c0 .28-.22.5-.5.5H17.2c-.44.01-.66-.53-.35-.84z'
      }
    ],
    width: '24',
    height: '24'
  }
})
